import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrollToPositionSource = new Subject<number>();
  scrollToPosition$ = this.scrollToPositionSource.asObservable();

  private storeScrollY = new Subject<number>();
  storeScroll$ = this.storeScrollY.asObservable();

  scrollPosition: number = 0;

  scrollTo(position: number): void {
    this.scrollToPositionSource.next(position || this.scrollPosition);
  }

  setScrollPosition(position): void {
    this.scrollPosition = position;
  }

  storeScroll(position: number): void {
    this.storeScrollY.next(position);
  }
}